module.exports = __webpack_public_path__ + "static/media/jo.7e63436c.svg";